module.exports = __webpack_public_path__ + "static/media/privacy-policy.451d3f5f.jpg";